import { ensureRouteData, prefetchRouteData } from '@/app/query-client'
import {
  planQueryOptions,
  plansQueryOptions,
  subscriptionMeQueryOptions,
} from '@/features/subscriptions/api/queries'
import type { RouterContext } from '@/routes/layouts/root'
import {
  resolveCheckoutPlan,
  switchablePlanIds,
} from '@/screens/account/components/checkout/checkoutModel'
import { checkoutSearchSchema } from '@/screens/account/subscription-search'

/**
 * The `/subscription/checkout` loader.
 *
 * MAIN, both awaited: the catalogue (which plan `?plan=` names, its price and
 * the tier's other periods) and the member's entitlement (whether their days
 * left carry over). Both are usually cached from `/subscription` already.
 *
 * SECONDARY, on a real navigation: the flags of every plan the page can
 * switch to, for the plan card's tagline — fetched now so "How often" and
 * the AI-signals choice never wait on one.
 */
export async function loadCheckout({
  context: { queryClient },
  location,
  preload,
}: {
  context: RouterContext
  location: { search: unknown }
  preload: boolean
}): Promise<void> {
  const [plans] = await Promise.all([
    ensureRouteData(queryClient, plansQueryOptions()),
    ensureRouteData(queryClient, subscriptionMeQueryOptions()),
  ])
  if (preload) return
  const { plan } = checkoutSearchSchema.parse(location.search)
  for (const planId of switchablePlanIds(resolveCheckoutPlan(plans, plan))) {
    prefetchRouteData(queryClient, planQueryOptions(planId))
  }
}
